// WebSocket events client. Auto-reconnects. Handlers can subscribe by event type.

import { getToken } from './api';

type Handler = (data: any) => void;
const handlers = new Map<string, Set<Handler>>();
let ws: WebSocket | null = null;
let reconnectTimer: number | null = null;
let extensionFilter: string | null = null;

export function connectWs(extension?: string) {
  extensionFilter = extension || null;
  const token = getToken();
  if (!token) return;
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const url = `${proto}//${window.location.host}/api/events?token=${encodeURIComponent(token)}${extension ? `&extension=${encodeURIComponent(extension)}` : ''}`;
  ws = new WebSocket(url);
  ws.onmessage = (ev) => {
    try {
      const msg = JSON.parse(ev.data);
      const set = handlers.get(msg.type);
      if (set) for (const h of set) h(msg.data);
      const all = handlers.get('*');
      if (all) for (const h of all) h(msg);
    } catch {}
  };
  ws.onclose = () => {
    if (reconnectTimer) return;
    reconnectTimer = window.setTimeout(() => {
      reconnectTimer = null;
      connectWs(extensionFilter || undefined);
    }, 2000);
  };
  ws.onerror = () => ws?.close();
}

export function disconnectWs() {
  if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
  ws?.close(); ws = null;
}

export function onEvent(type: string, h: Handler): () => void {
  if (!handlers.has(type)) handlers.set(type, new Set());
  handlers.get(type)!.add(h);
  return () => handlers.get(type)?.delete(h);
}
